// src/utils/confidenceUtils.js (Create this new file)

/**
 * Parses a string containing text and confidence scores like "Word<95.5>".
 * @param {string} value The input string.
 * @returns {{text: string, confidence: number | null}} Object with clean text and average confidence.
 */
export const parseValueWithConfidence = (value) => {
    if (typeof value !== 'string') {
      return { text: String(value), confidence: null };
    }
  
    const scoreRegex = /<(\d+(?:\.\d+)?)>/g;
    let scores = [];
    let match;
  
    while ((match = scoreRegex.exec(value)) !== null) {
      scores.push(parseFloat(match[1]));
    }
  
    const cleanText = value.replace(scoreRegex, '').replace(/\s+/g, ' ').trim(); // Remove scores and extra spaces
  
    if (scores.length === 0) {
      return { text: cleanText, confidence: null }; // Or return 100 if you prefer
    }
  
    const averageConfidence = scores.reduce((sum, score) => sum + score, 0) / scores.length;
    return { text: cleanText, confidence: parseFloat(averageConfidence.toFixed(2)) };
  };
  
  /**
   * Determines the color class based on confidence score.
   * @param {number | null} confidence The confidence score (0-100).
   * @returns {string} Tailwind CSS color classes.
   */
  export const getConfidenceColor = (confidence) => {
    if (confidence === null) return 'bg-gray-400'; // Neutral for no score
    if (confidence >= 95) return 'bg-green-500';
    if (confidence >= 80) return 'bg-yellow-500';
    return 'bg-red-500';
  };
  